<div class="container-right-main fluid-container">
    <div class="top-right-div">
        <div class="top-row">
            <div class="left-titl-buton ">
                <div class="title">
                    <h1>Manage FAQ's</h1>
                    <span class="baseline">Select any 4 FAQ's</span>
                </div>
            </div>
        </div>
        <div class="sec-row">
            <div class="sr-left-div">
            </div>
            <div class="right-filter">
                <div *ngIf="showNoSearchResultsMessage">
                    No search results found.
                </div>
            </div>
        </div>
        <div id="loader" class="loader"></div>
        <div class="d-flex align-right">
            <button (click)="addQuestion()" class="btn-white">+ New Question</button>
        </div>
        <div class="bottom-table">
            <div class="overflowxauto">
                <table class="assignee-table mat-elevation-z7" mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="faq">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            mat-sort-header="faq" class="tab-th">
                            Question
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td">
                            <span *ngIf="!selectedSourceName" class="clickable-row">
                                {{ element.faq }}
                            </span>
                            <span *ngIf="selectedSourceName">
                                {{ element.faq }}
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="region_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            sortActionDescription="Sort by region name" mat-sort-header="region_name" class="tab-th">
                            Region
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.region_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="created_by">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            mat-sort-header="created_by" class="tab-th">
                            Created By
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.created_by_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="created_on">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            mat-sort-header="created_on" class="tab-th">
                            Created Date
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.created_on | date: 'MM-dd-yyyy hh:mm a'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="updated_by">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            mat-sort-header="updated_by" class="tab-th">
                            Updated By
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.updated_by_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="updated_on">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            mat-sort-header="updated_on" class="tab-th">
                            Updated Date
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"> {{element.updated_on | date: 'MM-dd-yyyy hh:mm a'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            mat-sort-header="status" class="tab-th">
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td"><mat-slide-toggle class="custom-toggle"
                                [checked]="element.status === 'Y'" (change)="onStatusChange($event, element)">
                            </mat-slide-toggle></td>
                    </ng-container>


                    <ng-container matColumnDef="business_unit">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                            mat-sort-header="business_unit" class="tab-th">
                            Edit
                        </th>
                        <td mat-cell *matCellDef="let element" class="tab-td" (click)="editQuestion($event, element)">
                            <img src="../../../assets/images/icon-edit-new.svg" alt="Edit" class="icon-edit" />
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>
            </div>
        </div>
        <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons
            aria-label="Select page of periodic elements">
        </mat-paginator>
    </div>
</div>